'use client';

import { logOut } from '@/app_lib/services/tinypass/service';

export const SignOutButton = () => {
  const handleSignOut = () => {
    logOut();
  };

  return (
    <button
      className='cursor-pointer hover:text-neutral-400 focus:text-accent-primary'
      onClick={handleSignOut}
      type='button'
    >
      Sign Out
    </button>
  );
};
